import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import Utility from '../../../../../../../../util/utilityfunctions';
import {getRiskFactorById} from '../../../../../../../../selectors/ISA315/selectors';
import {useOverrideLabels} from '../../../../../../../Main/Forms/Utilities/OverrideLabelsProvider';
import RiskFactorListItem from './RiskFactorListItem';

function RiskFactorList({engagementId, headerId, bodyId, riskFactorsList, isDisabled}) {
	const {labels} = useOverrideLabels();

	const riskFactors = useSelector((state) =>
		riskFactorsList?.map((riskFactorId) => getRiskFactorById(state, riskFactorId))
	);
	const sortedRiskFactorIdList = riskFactors?.sort(Utility.sortByMultipleKey('riskFactorName')).map((rf) => rf.id);
	return (
		<StyledRiskFactorList className="StyledRiskFactorList">
			{sortedRiskFactorIdList?.length > 0 &&
				sortedRiskFactorIdList.map((riskFactorId) => (
					<RiskFactorListItem
						key={riskFactorId}
						engagementId={engagementId}
						headerId={headerId}
						bodyId={bodyId}
						riskFactorId={riskFactorId}
						isDisabled={isDisabled}
					/>
				))}
		</StyledRiskFactorList>
	);
}

RiskFactorList.propTypes = {
	engagementId: PropTypes.number,
	headerId: PropTypes.number,
	bodyId: PropTypes.number,
	riskFactorsList: PropTypes.arrayOf(PropTypes.number)
};

const StyledRiskFactorList = styled.section`
	margin: var(--px-8) 0 var(--px-8) var(--px-20);
	.riskfactorslist-column-titles {
		display: flex;
		border-bottom: var(--px-1) solid var(--neutrals-200);
		padding: var(--px-25) 0;
		font-size: var(--px-14);
		font-weight: bold;
		vertical-align: top;
		.column-risk-factor {
			width: 50%;
			padding-right: var(--px-40);
		}
		.column-relate-riskfactor {
			width: 35%;
			padding-right: var(--px-40);
		}
		.column-risk-type {
			width: 15%;
		}
	}
`;

export default RiskFactorList;
